import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const LOCAL_STORAGE_KEY = 'defaultdock';

@Injectable({
  providedIn: 'root'
})
export class DefaultService {

  constructor() { }

  private selectedDockCode$ = new BehaviorSubject<string | null>(this.loadDockCode());

  private loadDockCode(): string | null {
    return localStorage.getItem(LOCAL_STORAGE_KEY);
  }

  setDockCode(data: string) {
    localStorage.setItem(LOCAL_STORAGE_KEY, data); // persist in browser
    this.selectedDockCode$.next(data);             // notify current tab subscribers
  }

  private getDockCode() {
    return this.selectedDockCode$.asObservable();
  }

  getCurrentDockCode(): string | null {
    this.reloadFromStorage();
    return this.selectedDockCode$.getValue();
  }

  // Optional: To force reloading from localStorage (e.g. on refresh)
  private reloadFromStorage() {
    const data = this.loadDockCode();
    this.selectedDockCode$.next(data);
  }

}
